// extracted by mini-css-extract-plugin
module.exports = {"random":"styles_random__ZNMHw","boxes":"styles_boxes__1GJOc","buttons":"styles_buttons__1cPGG"};